<script setup lang="ts">
const { data: employerProfileBasic, pending: isLoadingEmployerProfileBasic } =
    useLazyAsyncData('employer-profile-basic', () =>
        $fetch('/api/commerce/product/faa8a6f7-2c96-4ac1-8d6b-2de20f465b49'),
    );
</script>

<template>
    <div class="mt-12 flex flex-col gap-16">
        <CommFeatureSection
            :images="[
                {
                    url: '/images/job-ads/features/employer-page/demo-page.webp',
                    alt: 'Die kostenlose employer.page am Beispiel einer Musterfirma mit einer Standorteinbindung in Landkartendarstellung.',
                },
            ]"
        >
            <template #text>
                <BaseText>
                    <BaseText as="span" variant="base-500">
                        Ihre reduzierte Arbeitgeberpräsenz:
                    </BaseText>
                    Die employer.page ist eine reduzierte Version des
                    Arbeitgeberprofils mit Grundinformationen über Ihr
                    Unternehmen als Arbeitgeber, wie Logo, kurzem Text und
                    Präsentation von bis zu drei Benefits. Individuelle
                    Anpassungen und das Hochladen von Bildern ist nicht möglich.
                </BaseText>
                <BaseText>
                    <BaseText as="span" variant="base-500">
                        Kostenfrei für alle Kunden:
                    </BaseText>
                    Das kostenfreie Arbeitgeberprofil ist für alle karriere.at
                    Kunden inklusive und kann über das Business Portal in der
                    Übersicht aktiviert und bearbeitet werden.
                </BaseText>
            </template>
        </CommFeatureSection>
        <div>
            <BaseHeading variant="lg-500" as="h3">
                Unsere Empfehlung für einen starken Arbeitgeberauftritt
            </BaseHeading>
            <div
                class="mt-6 flex min-h-[400px] flex-col items-center gap-7 rounded-lg bg-blue-300 p-7 lg:flex-row lg:gap-11 lg:px-16 lg:py-10"
            >
                <template v-if="!isLoadingEmployerProfileBasic">
                    <NuxtImg
                        :src="employerProfileBasic?.media?.['gallery']?.[0].url"
                        loading="lazy"
                        format="webp"
                        width="600px"
                        class="max-h-[350px] object-cover object-left-top"
                        decoding="auto"
                    />
                    <div>
                        <BaseHeading variant="lg-500" as="h4">
                            {{ employerProfileBasic.name }}
                        </BaseHeading>
                        <BaseText class="mt-3">
                            {{ employerProfileBasic.description }}
                        </BaseText>
                        <BaseText>
                            <ul class="mt-2 flex flex-col gap-2">
                                <CommBaseListItem
                                    v-for="(
                                        item, index
                                    ) in employerProfileBasic.features?.[
                                        'teaser-list'
                                    ]
                                        ?.filter(
                                            (feature) =>
                                                feature.value === 'active',
                                        )
                                        ?.slice(0, 5)"
                                    :key="index"
                                    icon-name="checkmark-filled-dark"
                                    icon-color="white"
                                    :info="item.info"
                                >
                                    <span v-html="item.label" />
                                </CommBaseListItem>
                            </ul>
                        </BaseText>
                        <JamBaseButton
                            class="mt-4 w-full lg:w-fit"
                            to="arbeitgeberprofil"
                            variant="gray"
                        >
                            Mehr erfahren
                        </JamBaseButton>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
